module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    ref: "multipleTable",
    attrs: {
      "data": _vm.dataList,
      "size": "mini"
    },
    on: {
      "selection-change": _vm.handleCheckChange
    }
  }, [(_vm.needCheck) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(item) {
    return _c('el-table-column', {
      key: item.id,
      attrs: {
        "label": item.label,
        "prop": item.prop,
        "align": _vm.align,
        "class-name": item.className,
        "label-class-name": item.labelClassName,
        "min-width": item.width,
        "fixed": item.fix || null
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._t("cell", null, {
            "row": scope.row,
            "column": scope.column,
            "index": scope.$index
          })]
        }
      }], null, true)
    })
  })], 2), _vm._v(" "), (_vm.needPagination) ? _c('el-pagination', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "current-page": _vm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": _vm.layout,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageNoChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21740bbf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21740bbf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageTable/pageTable.vue
// module id = 1267
// module chunks = 1